export default __webpack_public_path__ + "static/media/62.6d9a3af4.jpeg";